import axios from "axios"

const csrfToken =
  document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ||
  ""

export default axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  },
})
